import React from 'react'

const Check = () => (
    <svg viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <polygon points="21.982 10 13.335 19.608 9.708 15.98 9 16.688 13.373 21.06 22.726 10.669" />
    </svg>
)
export default Check
